import { authHeader } from '../_helpers';

const config = {
  apiUrl: 'http://localhost:8000'
};

if (process.env.NODE_ENV === 'production') {
  config.apiUrl = 'https://michma.in';
}

export const genericService = {
  apiCall,
  getHost
};

function getHost() {
  return config.apiUrl;
}

export function apiCall(endpoint, requestMethod, data) {
  let requestOptions = {
    method: requestMethod,
    headers: Object.assign({}, { 'Content-Type': 'application/json' }, authHeader())
  };

  if (data) {
    requestOptions = Object.assign({}, requestOptions, { body: JSON.stringify(data) });
  }
  return fetch(`${config.apiUrl}${endpoint}`, requestOptions)
    .then(handleResponse);
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem('user');
        window.location = '/signin';
      } else if (response.status === 403) {
        // do something here..
      }
      return Promise.reject(data);
    }

    return data;
  });
}



// WEBPACK FOOTER //
// ./src/_services/generic.service.js